import React, { Component } from 'react';

class BajaPreguntaConfirmacion extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        const { bajaCuentaData, numeroCuenta } = this.props;
        let tcAsociadas = bajaCuentaData.bajaCuenta13.CantidadTarjetasCuenta;

        return <div className="container-fluid saldos-resumenes">
            <div>
                <label>¿Confirma la baja de la Cuenta “{numeroCuenta}”?</label>
                <label>Las {tcAsociadas} Tarjetas de Crédito asociadas serán bloqueadas y quedaran inactivas.</label>
            </div>
        </div>
    }
};
export default BajaPreguntaConfirmacion;